import { render, staticRenderFns } from "./EditarInscricao.vue?vue&type=template&id=4efd56b8&scoped=true"
import script from "./EditarInscricao.vue?vue&type=script&lang=js"
export * from "./EditarInscricao.vue?vue&type=script&lang=js"
import style0 from "./EditarInscricao.vue?vue&type=style&index=0&id=4efd56b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd56b8",
  null
  
)

export default component.exports